import axios from "axios";

export const addGuestToEvent = async (eventCode, hostId, guestId) => {
  // console.log("addGuestToEvent", { eventCode, hostId, guestId });
  try {
    const response = await axios.patch("/events/add-guest", {
      inviteCode: eventCode,
      hostId,
      guestId,
    });

    return {
      message: response.data.message,
      isAlreadyInvited: response.data.isAlreadyInvited,
      event: response.data.event,
      isEventDatePassed: response.data.isEventDatePassed,
      isWrongRoleCode: response.data.isWrongRoleCode,
    };
  } catch (error) {
    return {
      message:
        error.response?.data?.message || "Failed to add guest to event",
      isAlreadyInvited:
        error.response?.data?.isAlreadyInvited ||
        error.response?.data?.message?.includes("already invited") ||
        false,
      isEventDatePassed: error.response?.data?.isEventDatePassed || false,
      isWrongRoleCode: error.response?.data?.isWrongRoleCode || false,
    };
  }
};
